

import { Mixins, Component, Prop } from 'vue-property-decorator';
import { StaticAttrsMixin } from '@/mixins/class-attr';
import IbListItemWithIconAndBadge from './ItemWithIconAndBadge.vue';
import { IList } from '../models';
import { IObjectAnyKeyVal } from '@/models/common';

@Component({
	components: {
		IbListItemWithIconAndBadge
	}
})
export default class ListWithIconAndBadge extends Mixins(StaticAttrsMixin) {

	@Prop({ type: Array, default: () => [] }) readonly items!: IList

	@Prop({ type: Boolean, default: false }) readonly dark!: boolean

	@Prop({ type: Boolean, default: false }) readonly large!: boolean

	@Prop({ type: Boolean, default: false }) readonly loading!: boolean

	public classObj: IObjectAnyKeyVal;

	constructor() {
		super();

		this.classObj = {
			'list': true,
			'dark': this.dark,
			'large': this.large,
			...this.staticClass
		};
	}

}

